import React from 'react'
import { useTranslation } from 'next-i18next'
import { EmtButton, EmtIcon, useMobile } from 'emt-components-v2'
import LinkButton from '@/components/EMT/LinkButton'
import { ProfileSidebar } from '@/components/Profile/partials'
import Box from '@mui/material/Box'

type Props = React.PropsWithChildren<{
  onClick: () => void
  dogType?: boolean
  disabled: boolean
  disabledDelete?: boolean
  loaderDelete?: boolean
  deleteProfile?: () => void
  loader?: boolean
  handleShare?: () => void
  color?:
    | 'primary'
    | 'secondary'
    | 'default'
    | 'inherit'
    | undefined
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
    | 'purple'
}>

export const EditProfileSidebar: React.FC<Props> = ({
  onClick,
  dogType = false,
  disabled,
  loader = false,
  color = 'primary',
  deleteProfile,
  disabledDelete = false,
  loaderDelete = false,
  handleShare,
}) => {
  const [isMobile] = useMobile()
  const { t } = useTranslation('profile')

  return (
    <>
      {/* Desktop */}
      {!isMobile && (
        <ProfileSidebar id="profile-sidebar">
          {dogType && <FicheToutouButton disabled={disabledDelete} loader={loaderDelete} color={color} />}
          {deleteProfile && (
            <DeleteButton onClick={deleteProfile} disabled={disabledDelete} loader={loaderDelete} color={color} />
          )}
          <SaveButton onClick={onClick} disabled={disabled} loader={loader} color={color} />
          {handleShare && (
            <EmtButton
              fullWidth
              color={color}
              size="large"
              variant="outlined"
              startIcon={<EmtIcon className="emt-upload" />}
              onClick={handleShare}
            >
              {t('profileSidebar.share')}
            </EmtButton>
          )}
        </ProfileSidebar>
      )}
      {/* END Desktop */}

      {/* Mobile */}
      {isMobile && (
        <Box
          sx={{
            position: 'fixed',
            display: 'flex',
            gap: '8px',
            bottom: '30px',
            left: '5%',
            width: '90%',
            zIndex: 12000,
          }}
        >
          <SaveButton onClick={onClick} disabled={disabled} loader={loader} color={color} />
        </Box>
      )}
      {/* END Mobile */}
    </>
  )
}

type SaveButtonProps = {
  onClick: () => void
  disabled: boolean
  loader: boolean
  color?:
    | 'primary'
    | 'secondary'
    | 'default'
    | 'inherit'
    | undefined
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
    | 'purple'
}

const SaveButton: React.FC<SaveButtonProps> = ({ onClick, disabled, loader, color = 'primary' }) => {
  const { t } = useTranslation('profile')

  return (
    <Box width={'100%'} className="EmtReactNativeWebViewPaddingBottom">
      <EmtButton
        fullWidth
        color={color}
        size="large"
        startIcon={<EmtIcon className="emt-save" />}
        disabled={disabled}
        onClick={onClick}
        loader={loader}
      >
        {t('profileSidebar.save')}
      </EmtButton>
    </Box>
  )
}

const DeleteButton: React.FC<SaveButtonProps> = ({ onClick, disabled, loader, color = 'primary' }) => {
  const { t } = useTranslation('profile')

  return (
    <EmtButton
      fullWidth
      color={color}
      size="large"
      variant="outlined"
      startIcon={<EmtIcon className="emt-bin" />}
      disabled={disabled}
      onClick={onClick}
      loader={loader}
    >
      {t('profileSidebar.delete')}
    </EmtButton>
  )
}

const FicheToutouButton: React.FC<Omit<SaveButtonProps, 'onClick'>> = ({ disabled, loader, color = 'primary' }) => {
  const { t: th } = useTranslation('home')

  return (
    <LinkButton
      fullWidth
      color={color}
      href={th('content.tips.dogForm.link')}
      target="_blank"
      size="large"
      variant="outlined"
      startIcon={<EmtIcon className="emt-text-document" />}
      disabled={disabled}
      loader={loader}
    >
      {th('content.tips.dogForm.title')}
    </LinkButton>
  )
}
